'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = exports.calcFieldState = exports.selectFieldValue = exports.selectField = exports.getFormState = exports.fieldSelector = exports.selectPrefix = exports.getPrefix = exports.getFieldSelector = exports.selectForm = exports.REDUCER_KEY = undefined;

var _getOr2 = require('lodash/fp/getOr');

var _getOr3 = _interopRequireDefault(_getOr2);

var _concat2 = require('lodash/fp/concat');

var _concat3 = _interopRequireDefault(_concat2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.getErrorVal = getErrorVal;
exports.getStatus = getStatus;
exports.derivedState = derivedState;
exports.selectFieldState = selectFieldState;
exports.getFieldState = getFieldState;
exports.getFieldValue = getFieldValue;
exports.fieldValue = fieldValue;

var _reselect = require('reselect');

var _capeSelect = require('cape-select');

var _reducer = require('./reducer');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUCER_KEY = exports.REDUCER_KEY = 'form';

var selectForm = exports.selectForm = (0, _property3.default)(REDUCER_KEY);

// fieldSelector(prefixArray)(state)
var getFieldSelector = exports.getFieldSelector = (0, _partial3.default)(_capeSelect.select, selectForm);

function getErrorVal(state, _ref) {
  var pristine = _ref.pristine,
      validate = _ref.validate;

  if (pristine && !state.error) return null;
  if ((0, _isFunction3.default)(validate)) {
    var errorVal = validate(state.value);
    if (errorVal) return errorVal;
  }
  if (state.invalid[state.value]) return state.invalid[state.value];
  return state.error;
}
function getStatus(errorVal, isValid) {
  if (isValid) return 'success';
  if (!errorVal) return null;
  return errorVal.status || 'error';
}
// Validate function should return a string or object
// error: { message: String, suggestion: String, status: String }
function derivedState(state, initialValue, validate) {
  var initVal = state.initialValue || initialValue || _reducer.defaultState.initialValue;
  var pristine = state.value === initVal;
  var errorVal = getErrorVal(state, { pristine: pristine, validate: validate });
  var isValid = !errorVal && !pristine;
  var isOpen = state.blur || state.focus;
  return state.merge({
    errorMessage: errorVal && errorVal.message ? errorVal.message : errorVal,
    hasError: !!errorVal,
    initialValue: initVal,
    invalidValue: state.invalid[state.value] || null,
    isClosed: !isOpen,
    isDirty: !pristine,
    isEditing: state.focus && !pristine,
    isOpen: isOpen,
    isPristine: pristine,
    isSaved: !pristine && state.value === state.savedValue,
    isValid: isValid,
    status: getStatus(errorVal, isValid),
    suggestion: errorVal && errorVal.suggestion ? errorVal.suggestion : null,
    validValue: state.valid[state.value] || null
  });
}
// export function calcState(state) {
// }

// The new core of selecting state based on prefix.
var getPrefix = exports.getPrefix = (0, _property3.default)('prefix');
var selectPrefix = exports.selectPrefix = (0, _flow3.default)((0, _nthArg3.default)(1), getPrefix, _utils.createPrefix);
var fieldSelector = exports.fieldSelector = (0, _flow3.default)(_utils.createPrefix, (0, _concat3.default)(REDUCER_KEY), (0, _getOr3.default)(_reducer.defaultState));
var getFormState = exports.getFormState = (0, _flow3.default)(getPrefix, fieldSelector);
var selectField = exports.selectField = function selectField(state, props) {
  return getFormState(props)(state);
};
var selectFieldValue = exports.selectFieldValue = (0, _flow3.default)(selectField, (0, _property3.default)('value'));
var calcFieldState = exports.calcFieldState = (0, _flow3.default)(selectField, derivedState);

// Older stuff
// Please note that it will return defaultState if there is an invalid prefix.
function selectFieldState(state, prefix) {
  var selectFormState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : selectForm;

  return (0, _get3.default)(selectFormState(state), (0, _utils.createPrefix)(prefix), _reducer.defaultState);
}
// Select prefix and selectForm from props.
function getFieldState(state, props) {
  return selectFieldState(state, props.prefix, props.selectForm);
}
var getState = exports.getState = (0, _reselect.createSelector)(getFieldState, (0, _capeSelect.getProp)('initialValue'), (0, _capeSelect.getProp)('validate'), derivedState);
function getFieldValue(state, prefix, selectFormState) {
  var prop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'value';

  return (0, _get3.default)(selectFieldState(state, prefix, selectFormState), prop);
}

// Returns selector.
function fieldValue(prefix) {
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  return function (state) {
    return (0, _get3.default)(selectFieldState(state, prefix), prop);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-field/lib/select.js
// module id = 1266
// module chunks = 0